import * as Constants from './Constants';

const initialState = {
  title: '',
  updateCartFail: false,
  updateCartFailResponse: {},
  clearCart: false,
};

function expressCartReducer(state = initialState, action) {
  switch (action.type) {
    case Constants.GET_DATA_SUCCESS:
      return { ...state, title: action.response && action.response.data };
    case Constants.PARTNER_AVL:
      return { ...state, partnerData: action.response && action.response.data };
    case Constants.UPDATE_CART_FAIL:
      return { ...state, updateCartFail: action.response };
    case Constants.UPDATE_CART_FAIL_RESPONSE:
      return { ...state, updateCartFailResponse: action.response };
    case Constants.DAW_COUPON:
      return { ...state, dawCoupon: action.value ? action.value : '' };
    case 'RESET_CART': {
      return { ...state, clearCart: action.value };
    }
    default:
      return state;
  }
}

export default expressCartReducer;
